import { createFileRoute } from "@tanstack/react-router";
import { Card } from "@/components/ui/card";
import { PageHeader } from "@/components/PageHeader";
import { Footer } from "@/components/Footer";

export const Route = createFileRoute("/terms")({
  component: TermsPage,
  head: () => ({
    meta: [
      { title: "Terms of Service - RobotDex" },
      { name: "description", content: "RobotDex Terms of Service - rules for using the RobotDex NFT marketplace." },
    ],
  }),
});

function TermsPage() {
  return (
    <div>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8">
        <PageHeader title="Terms of Service" subtitle={`Last updated: ${new Date().toLocaleDateString()}`} />
        <Card className="p-6 bg-card/60 neon-border space-y-6 text-sm leading-relaxed">
          <Section title="1. Acceptance">
            By accessing RobotDex ("the Platform"), you agree to these Terms. If you do not agree, do not use the Platform.
          </Section>
          <Section title="2. Nature of the service">
            RobotDex is a non-custodial, on-chain interface to public blockchain networks including Robinhood Chain and other EVM-compatible chains. RobotDex does not hold user funds, private keys, or NFTs. All transactions are executed by the user's own wallet on public blockchains.
          </Section>
          <Section title="3. Eligibility">
            You must be legally able to enter into a binding contract in your jurisdiction, and use of the Platform must not violate any laws that apply to you.
          </Section>
          <Section title="4. Wallets & transactions">
            You are solely responsible for the security of your wallet, seed phrase, and private keys. Blockchain transactions are irreversible. Gas fees, mint prices, listing prices, and platform fees are paid directly from your wallet.
          </Section>
          <Section title="5. User-generated content">
            Creators are solely responsible for the content, metadata, artwork, name, and description of any NFT they mint. You must have all rights necessary to publish that content. RobotDex may hide content that violates these Terms or applicable law.
          </Section>
          <Section title="6. Platform fees & royalties">
            RobotDex charges a platform fee on successful mints and successful trades. Creators may receive royalties on secondary sales. Current fee percentages are set on-chain by the Platform and visible in the app.
          </Section>
          <Section title="7. No investment advice">
            NFTs, tokens, and any assets referenced on RobotDex are not investment products. Nothing in the Platform is financial, legal, or tax advice.
          </Section>
          <Section title="8. Disclaimers">
            The Platform is provided "as is" without warranties of any kind. RobotDex is not liable for losses caused by network congestion, smart-contract bugs, malicious contracts, third-party wallets, or user error.
          </Section>
          <Section title="9. Prohibited activity">
            Do not use the Platform to launder funds, evade sanctions, infringe intellectual property, distribute malware, run wash trades, or otherwise engage in illegal activity.
          </Section>
          <Section title="10. Changes">
            RobotDex may update these Terms at any time. Continued use of the Platform after changes constitutes acceptance.
          </Section>
          <Section title="11. Contact">
            Questions about these Terms can be sent to the RobotDex team via the community channels listed in the footer.
          </Section>
        </Card>
      </div>
      <Footer />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="font-semibold text-base mb-1 neon-text">{title}</h2>
      <p className="text-muted-foreground">{children}</p>
    </div>
  );
}
